import React from 'react';
import { useNavigate } from 'react-router-dom';

import { FlexBox, FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { TextButton } from '@ecp/common/src/components/button/TextButton';
import StyledImg from '@ecp/common/src/components/image/StyledImg';
import { WELSTORY_URL } from '@ecp/common/src/const/footer';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import { NoneDecorationLink } from '@ecp/common/src/text/TextLink';

const MemberTop = () => {
  const navigate = useNavigate();
  const {
    systemInformation: { pcGnbImgFilePath, loginQuestUseYn },
  } = useSiteInfo();
 

  return (
    <FlexBoxColumn width={'100%'}>
      <FlexBox align-items="center" justify-content={'space-between'} width={'1540px'} height={'54px'}>
        <NoneDecorationLink to={'/'}>
        <StyledImg maxHeight={'51px'} src={pcGnbImgFilePath} alt={'LargeLogoIcon'} cursor={'default'} />
        </NoneDecorationLink>
        <FlexBox gap={'30px'}>
          {loginQuestUseYn === 'Y' && (
            <>   
            {(window.location.host.indexOf('www.welstorymall.com') != -1 ||  
              window.location.host.indexOf('stgfo.welstorymall.com') != -1 ||
              window.location.host.indexOf('devfo.welstorymall.com') != -1
            ) && (                       
              <>
                <TextButton textProps={{ size: '16px' }} onClick={() => navigate('/member/b2e-affiliate')}>
                  B2E 제휴문의
                </TextButton>
                <TextButton textProps={{ size: '16px' }} onClick={() => navigate('/member/brand-inquiry')}>
                  입점문의
                </TextButton>
              </> 
            )}             
              <TextButton textProps={{ size: '16px' }} onClick={() => window.open(WELSTORY_URL)}>
                회사소개
              </TextButton>
            </>           
          )}
        </FlexBox>
      </FlexBox>
      <HorizontalDivider width="100%" height="1px" color="#dfdfdf" />
    </FlexBoxColumn>
  );
};

export default MemberTop;
